export const LineChartIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    className={className}
  >
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        fill-opacity=".87"
        fill-rule="evenodd"
        d="m16.619 7.893-5.167 3.061a.654.654 0 0 1-.373.175.572.572 0 0 1-.587-.187L7.645 8.123l-2.853 2.831a.679.679 0 0 1-.953 0 .667.667 0 0 1 0-.943l3.326-3.3a.687.687 0 0 1 .96 0l2.887 2.862 5.02-2.978a.612.612 0 0 1 .887.296.804.804 0 0 1-.3 1.002Zm-.307 7.274a.667.667 0 1 1 0 1.333H1.645a.666.666 0 0 1-.666-.667V1.167a.667.667 0 1 1 1.333 0v14h14Z"
        clip-rule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M.979.5h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
);
